
import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import AdLayout from '../components/AdLayout';
import NewReconciliation from './NewReconciliation';
import NormalInvoices from './NormalInvoices';

function ReconciliationManagement() {
  const [searchParams, setSearchParams] = useSearchParams();
  const rawTab = searchParams.get('tab') || 'new';
  const [activeTab, setActiveTab] = useState(rawTab === 'file' ? 'new' : rawTab);

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setSearchParams({ tab });
  };

  return (
    <div>
      <AdLayout>
        <div className="table-responsive web-table">
          <div className="tab-container">
            <nav>
              <div className="nav nav-tabs" id="nav-tab" role="tablist">
                <button
                  className={`nav-link ${activeTab === 'new' ? 'active' : ''}`}
                  onClick={() => handleTabChange('new')}
                >
                  Chưa đối soát
                </button>
                <button
                  className={`nav-link ${activeTab === 'done' ? 'active' : ''}`}
                  onClick={() => handleTabChange('done')}
                >
                  Đã đối soát
                </button>
              </div>
            </nav>
            <div className="tab-content bg-white" id="nav-tabContent">
              <div className="tab-pane fade show active" role="tabpanel">
                {activeTab === 'new' && <NewReconciliation />}
                {activeTab === 'done' && <NormalInvoices embedded={true} />}
              </div>
            </div>
          </div>
        </div>
      </AdLayout>
    </div>
  );
}
export default ReconciliationManagement;
